<template>
    <div >
        <transition name="fade" enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    :duration="300">
            <div class="cover-layer" v-show="isKeyResultShow&&keyword&&keyResult"></div>
        </transition>
        <transition  name="fadeInUp" >
            <div class="m-search-content" ref="search" v-show="isKeyResultShow&&keyword&&keyResult">
                <table class="content-table" >
                    <tr>
                        <td class="content-label" v-if="DestType != 0"><i class="iconfont icon-jiudian"></i>城市</td>
                        <td v-if="DestType != 0">
                            <div v-for="(city,index) in keyResult.Cities" v-show="index<5" @click="selectCity(city)">
                                <label v-html="highLight(city.CName,keyword)"></label>
                                <span class="hotel-count">{{city.HotelCount}}家酒店</span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="content-label" v-if="DestType == 0"><i class="iconfont icon-hotel"></i>酒店</td>
                        <td v-if="DestType == 0">
                            <div  v-for="hotel in keyResult.Hotels" @click="selectHotel(hotel)">
                                <label v-html="highLight(hotel.Name,keyword)"></label>
                                <label class="en-name" v-html="highLight(hotel.EnName,keyword)"></label>
                                <span class="price-one">￥{{hotel.LowestPrice}}起</span>
                                <span class="score-two">{{hotel.Rate}}分,超棒</span>
                            </div>
                        </td>
                    </tr>
                    <tr >
                        <td class="content-label" v-if="DestType != 0"><i class="iconfont icon-lmy-dingwei"></i>商圈</td>
                        <td v-if="DestType != 0">
                            <div v-for="(landmark,idx) in keyResult.Landmarks" v-show="idx<5" @click="selectLandmark(landmark)">
                                <label v-html="highLight(landmark.Name,keyword)"></label>
                                <span class="hotel-count">{{landmark.HotelCount}}家酒店</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </transition>
    </div>
</template>
<script>
    export default{
        name:'searchALl',
        props:{
            keyword:{
                type:String,
                default:''
            },
            DestType:{
                type:Number,
                default:0
            },
            isKeyResultShow:{
                type:Boolean,
                default:false
            },
            productType:{
                type:String,
                default:null
            }
        },
        data(){
            return{
                keyResult:'',
                key:''
            }
        },
        watch:{
            keyword(val){
                this.getHotelAndLandmarks(val);
            }
        },
        methods:{
            //选择城市
            selectCity(city){
                this.$emit('selectCity',city)
            },
            //选择酒店
            selectHotel(hotel){
                console.log(hotel);
                this.$emit('selectHotel',hotel)
            },
            //选择地标
            selectLandmark(landmark){
                console.log(landmark);
                this.$emit('selectLandmark',landmark)
            },
            //字符串关键字高亮
            highLight(string,key){
                if(!string)return;
                var array=[];
                var str='';
                array=string.split('');
                for(var i=0;i<array.length;i++){
                    if(key.indexOf(array[i])>-1){
                        str+='<span class="key-words">'+array[i]+'</span>';
                    }else{
                        str+=array[i];
                    }
                }
                return str;
            },
            //模糊查询
            getHotelAndLandmarks(){
                var that=this;
                var params={
                    q:that.keyword,
                    pt:that.productType,
                    page:1,
                    pageSize:5,
                }
                that.getRequest({
                    url: that.Api.getHotelAndLandmarks,
                    params: params
                }).then(res => {
                    if (res&&res.IsSuccess) {
                        that.keyResult=res.Result;
                        that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }    
                        })
                    }
                });
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click',this.onClick,false)
            },
            onClick(e){
                if (e.target.className == 'searchAll' || this.$refs.search && this.$refs.search.contains(e.target)) return;
                this.$emit('selectHotel')
            }
        },
        destroyed(){
            document.removeEventListener('click', this.onClick,false)
        },
        mounted() {
            this.addCloseListener()
        },
    }
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/regimentRoomSearch/regimentRoomSearch.vue